<template>
  <div>
    <div class="phoneMenu" v-if="personalInfo">
      <div class="title">
        <div class="title_img">
          <el-image
              style="width: 100px; height: 100px"
              :src="personalInfo?(role==3?(personalInfo.view1?imgPath+personalInfo.view1:'/image/personal/default_ava.jpg'):(personalInfo.photo_path?imgPath+personalInfo.photo_path:'/image/personal/morentx.png')):'/image/personal/morentx.png'"
              :preview-src-list="personalInfo?[(role==3?(personalInfo.view1?imgPath+personalInfo.view1:'/image/personal/default_ava.jpg'):(personalInfo.photo_path?imgPath+personalInfo.photo_path:'/image/personal/morentx.png'))]:['/image/personal/morentx.png']"
          ></el-image>
        </div>
        <div class="title_wenzi">
          <h3
              style="padding: 10px 10px"
          >{{
              personalInfo ? (role == 1 || role == 2 ? personalInfo.name : role == 3 ? personalInfo.mechanism_fullName : '') : ''
            }}</h3>
          <span v-if="personalInfo && role==2">{{ personalInfo.evaluator_rank|app_grade }}</span>
          <span v-if="personalInfo && role==1">{{ personalInfo.athlete_rank|grade }}</span>
        </div>
        <div class="operate">
          <div class="operate-t">
            <img src="/image/personal/icon.png"/>
            <label>{{ title }}</label>
          </div>
        </div>
      </div>
      <!-- 根据角色判断需要显示路由 -->
      <ul class="operate-b">
        <template
            v-for="(item,index) in (role==1?dataList:role==2?dataList1:role==3?dataList2:dataList3)"
        >
          <!-- <router-link :to="item.path" :key="index" > -->
          <li
              :class="item.path == navPath ?'light':''"
              :key="index"
              style="cursor: pointer;"
              @click="select(item.path)"
          >
            <!-- :to="personalInfo || item.name == '账户安全'?item.path:'/personal/completeInformation'" -->
            <img :src="item.src"/>
            <span>{{ item.name }}</span>
          </li>
          <!-- </router-link> -->
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GetDicData} from "@/api/admin/common.js";
//声明一个全局变量
let that;
export default {
  props: ["role"],
  computed: {
    ...mapGetters(["personalInfo"])
  },
  data() {
    return {
      menurole: "",
      title: "",
      name: "lucky",
      level: "一级运动员",
      // 运动员
      dataList: [
        {
          path: "/personal/gradeTestRecord",
          name: "等级测试记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/competitionApplication",
          name: "赛事申请",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/competitionApplicationRecord",
          name: "赛事申请记录",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/gradeCertificate",
          name: "等级证书",
          src: "/image/personal/icon5.png"
        },
        {
          path: "/personal/invoiceList",
          name: "发票记录",
          src: "/image/personal/icon6.png"
        },
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      // 考评员
      dataList1: [
        {
          path: "/personal/trainingRecord",
          name: "培训记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/workRecord",
          name: "工作记录",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/gradeCertificate",
          name: "等级证书",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/invoiceList",
          name: "发票记录",
          src: "/image/personal/icon6.png"
        },
        {
          path: "/personal/payRecord",
          name: "缴费记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      // 测试机构
      dataList2: [
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/qualificationApplication",
          name: "资质申请",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/contractList",
          name: "合同管理",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/testList",
          name: "测试列表",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/complaintHandling",
          name: "申诉处理",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/orderCenter",
          name: "订单中心",
          src: "/image/personal/icon3.png"
        },
        // {
        //    path: "/personal/pliceApplication",
        //    name: "考点申请",
        //    src: "/image/personal/icon5.png"
        // },

        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      dataList3: [],
      navPath: "",
      certificate_grade: [],
      appraiser_grade: [],
      imgPath: window.apiObj.apiUrl,
      srcList: ["/image/personal/head_portrait.jpg"]
    };
  },
  watch: {
    $route() {
      this.checkRouterLocal();
    }
  },
  created() {
    this.checkRouterLocal();
    this.dicData();
    //判断进入的角色
    this.menurole = this.role;
    if (this.menurole == 1 || this.menurole == 2) {
      this.title = "个人中心";
    } else if (this.menurole == 3) {
      this.title = "机构主页";
    }
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    // 检索当前路径
    checkRouterLocal() {
      // 查找当前路由下标高亮

      this.navPath = this.$route.meta.lightPath;

    },
    select(path) {
      if (!this.personalInfo) {
        this.$message({
          showClose: true,
          message: "请完善您的个人信息",
          type: "warning"
        });
      }
      if (this.role == 3) {
        if (
            path == "/personal/testList" ||
            path == "/personal/complaintHandling" ||
            path == "/personal/orderCenter" ||
            path == "/personal/pliceApplication"
        ) {
          if (
              this.personalInfo.approval_status == 1 ||
              this.personalInfo.approval_status == 2 ||
              this.personalInfo.approval_status == 4 ||
              !this.personalInfo.approval_status
          ) {
            this.$message({
              message: "请通过资质申请",
              type: "warning"
            });
            // return false
          }
        }
      }
      this.$router.push({path: path});
    },
    dicData() {
      GetDicData({classCode: "certificate_grade"}).then(data => {
        if (data.data.result) {
          this.certificate_grade = data.data.result;
        }
      });
      GetDicData({classCode: "appraiser_grade"}).then(data => {
        if (data.data.result) {
          this.appraiser_grade = data.data.result;
        }
      });
    }
  },
  filters: {
    grade: data => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    },
    app_grade: data => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.phoneMenu {
  .title {
    background: #f3fafd;
    padding: 15px 0;
    // margin-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;

    .title_img {
      padding: 10px;

      img {
        width: 100px;
        height: 100px;
      }
    }

    .title_wenzi {
      span {
        color: crimson;
      }
    }

    .operate {
      position: absolute;
      right: 0px;
      bottom: 2px;
      padding: 5px 13px;
      background: #cde8fe;

      .operate-t {
        img {
          position: relative;
          top: 4px;
          left: -2px;
          width: 20px;
          height: 20.7px;
        }
      }
    }
  }

  .operate-b {
    background: #cde8fe;
    display: flex;
    justify-content: space-between;

    li {
      padding: 6px;
      background: #cde8fe;
      text-align: center;

      img {
        width: 16px;
        height: 18px;
      }

      span {
        display: block;
        color: #000;
        font-size: 14px;
      }
    }

    .light {
      background: #8dc3ff;
    }
  }
}
</style>
